@if (isInitialized) {
  <oe-flat-widget [modalComponent]="modalComponent" [title]="component.alias"
    [icon]="{color: 'normal', name:'flame'}">
    <oe-flat-widget-line [name]="'GENERAL.MODE'| translate"
    [channelAddress]="component.id + '/_PropertyMode'"></oe-flat-widget-line>
    <oe-flat-widget-line name="Floor Temperature" [channelAddress]="component.id + '/FloorActual'"
    [converter]="Utils.CONVERT_DEZIDEGREE_CELSIUS_TO_DEGREE_CELSIUS"></oe-flat-widget-line>
    <oe-flat-widget-line name="Ambient Temperature" [channelAddress]="component.id + '/AmbientActual'"
    [converter]="Utils.CONVERT_DEZIDEGREE_CELSIUS_TO_DEGREE_CELSIUS"></oe-flat-widget-line>
    <oe-flat-widget-line name="Power Consumption" [channelAddress]="component.id + '/ActivePower'"
    [converter]="Utils.CONVERT_WATT_TO_KILOWATT"></oe-flat-widget-line>
  </oe-flat-widget>
}